/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

const extensionHighlight: Record<string, string> = {
	py: 'python',
	gyp: 'python',
	wsgi: 'python',
	htm: 'html',
	xhtml: 'html',
	erl: 'erlang',
	jsp: 'java',
	pl: 'perl',
	rss: 'xml',
	atom: 'xml',
	xsl: 'xml',
	plist: 'xml',
	rb: 'ruby',
	builder: 'ruby',
	gemspec: 'ruby',
	podspec: 'ruby',
	thor: 'ruby',
	diff: 'patch',
	hs: 'haskell',
	icl: 'haskell',
	php3: 'php',
	php4: 'php',
	php5: 'php',
	php6: 'php',
	sh: 'bash',
	zsh: 'bash',
	st: 'smalltalk',
	as: 'actionscript',
	apacheconf: 'apache',
	osacript: 'applescript',
	b: 'brainfuck',
	bf: 'brainfuck',
	clj: 'clojure',
	'cmake.in': 'cmake',
	coffee: 'coffeescript',
	cson: 'coffescript',
	iced: 'coffescript',
	c: 'cpp',
	h: 'cpp',
	'c++': 'cpp',
	'h++': 'cpp',
	hh: 'cpp',
	jinja: 'django',
	bat: 'dos',
	cmd: 'dos',
	fs: 'fsharp',
	hbs: 'handlebars',
	'html.hbs': 'handlebars',
	'html.handlebars': 'handlebars',
	sublime_metrics: 'json',
	sublime_session: 'json',
	'sublime-keymap': 'json',
	'sublime-mousemap': 'json',
	'sublime-project': 'json',
	'sublime-settings': 'json',
	'sublime-workspace': 'json',
	js: 'javascript',
	mk: 'makefile',
	mak: 'makefile',
	md: 'markdown',
	mkdown: 'markdown',
	mkd: 'markdown',
	nginxconf: 'nginx',
	m: 'objectivec',
	mm: 'objectivec',
	ml: 'ocaml',
	rs: 'rust',
	sci: 'scilab',
	txt: 'plaintext',
	vb: 'vbnet',
	vbs: 'vbscript',
}

export { extensionHighlight }
